
import { defineComponent, ref } from "vue";
import firebase from "firebase/app";
import Check from "./Check.vue";
import features from "./feature-matrix";

export default defineComponent({
  name: "Pricing",
  setup() {
    // UI
    const gutters = [
      "mx-auto",
      "xl:max-w-5xl",
      "lg:max-w-4xl",
      "px-4",
      "sm:px-8",
      "lg:px-10"
    ];

    const annualPricing = ref(true);
    const prices = ref({
      indie: { month: 0, year: 0 },
      pro: { month: 1, year: 1 }
    });

    // Get price data
    const db = firebase.firestore();
    db.collection("stripe_products")
      .where("active", "==", true)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(productDoc => {
          const product = productDoc.data();
          const tier = product.role as "indie" | "pro";
          productDoc.ref
            .collection("prices")
            .where("active", "==", true)
            .get()
            .then(snap => {
              for (const priceDoc of snap.docs) {
                const price = priceDoc.data();
                const amount = price.unit_amount;
                const interval = price.interval as "month" | "year";
                prices.value[tier][interval] =
                  amount / 100 / (interval === "year" ? 12 : 1);
              }
            });
        });
      });
    return {
      gutters,
      annualPricing,
      prices,
      featureSetQuotas: features.featuresQuotas,
      featureSetFlags: features.featuresFlags,
      mailto: "mailto:team@samplyaudio.com?subject=Samply%20Pro%20Inquiry"
    };
  },
  components: {
    Check
  }
});
